/**
 * External dependencies
 */
import React from 'react';
import classNames from 'classnames';

/**
 * Internal dependencies
 */
import Icon from 'components/icon';

/**
 * Style dependencies
 */
import './styles.scss';

const ErrorContent = (props) => {
    const classes = classNames('me-error-content', { 'me-error-content--inline': props.inline});
    return (
        <div className={classes}>
            <div className='me-error-content__icon'>
                <Icon name={props.iconName} type={props.iconType} />
            </div>
            <div className='me-error-content__text-wrapper'>
                <p className='text-center'>{props.message}</p>
    
            </div>
        </div>
    );
};

ErrorContent.defaultProps = {
    message: 'Something broke. Reload page to try again.',
    iconName: 'FiFrown'
};

ErrorContent.propTypes = {};

export default ErrorContent;
